    <button 
      class="point-actions__button point-actions__button--recover"
      [attr.aria-label]="'Recuperar recurso' | translate"
      (click)="handleRecoverPointClick()"
    >
      <ci-icon
        class="point-actions__icon"
        name="undo"
        type="svg"
      ></ci-icon>
      
      <span class="point-actions__text ci-footer-regular">
        {{ 'Recuperar recurso' | translate }}
      </span>
    </button>